import React, { useState } from 'react';
import './Search.css';
import SearchBar from '../../component/Search/SearchBar';

import tiktakaLogo from '../../assets/tiktakaLogo.png';

// Website Mobile Logo
import mobileLogo from '../../assets/tiktaka_logo_mobile.png';

import yourAdHere from '../../assets/ad-now.jpg';

// After Login image profile
// import profileImg from '../../assets/profile.jpg';

// LogOut Icon
// import LogoutIcon from '@mui/icons-material/Logout';

import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import ExploreIcon from '@mui/icons-material/Explore';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddBoxIcon from '@mui/icons-material/AddBox';

import LoginIcon from '@mui/icons-material/Login';

import { Link  , NavLink} from 'react-router-dom';

import Helmet from '../../component/Helmet/Helmet';

import SearchResultsList from '../../component/Search/SearchResultsList';
import RightSide from '../../component/layouts/rightSide';
import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';


const Search = () => {

    const [results, setResults] = useState([]);

    
  return (
  <Helmet title='Search'>
    <div className="Search">

    <Sidebar />

  
    <div className='midSide'>
    <div className='middleSideHome'>
     
     <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='mainSection'>
            <div className='searchBarContainer'>
           <SearchBar setResults={setResults} />
           <SearchResultsList results={results} />
            
        </div>
        </div>
    </div>
    </div>
       <RightSide />

  </div>
  </Helmet>
  );
};

export default Search;